/**
 * Export component file to be used on project
 */

import Header from './Header';
export default Header;